export enum SkipAdminStatus {
    REVIEWED = 'REVIEWED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED'
}
